const palette = {
  base: {
    white: '#E6E6E6',
    black: '#1A1A1A',
    grey: '#141414',
  },
  common: {
    pureWhite: '#FFFFFF',
    pureBlack: '#000000',
    transparent: '#FFFFFF1A',
    // Commonly used grays
    gray50: '#fafafa',
    gray100: '#f7f7f7',
    gray200: '#f0f0f1',
    gray300: '#ececed',
    gray400: '#cecfd2',
    gray500: '#85888e',
    gray600: '#787878',
    gray700: '#61656c',
    gray800: '#373a41',
    gray900: '#13161b',
  },
  brand: {
    0: '#ffb56a00',
    25: '#fff5ea',
    50: '#fff8ed',
    100: '#ffefd4',
    200: '#ffdca8',
    300: '#ffc171',
    400: '#ffad59',
    500: '#ff9830',
    600: '#ee8536',
    700: '#b75123',
    800: '#91411e',
    900: '#75371a',
    950: '#3f190b',
  },
  brandAlpha: {
    500: '#ff983044',
  },
  purple: {
    25: '#FAFAFF',
    50: '#F4F3FF',
    100: '#EBE9FE',
    200: '#D9D6FE',
    300: '#BDB4FE',
    400: '#9B8AFB',
    500: '#7A5AF8',
    600: '#6938EF',
    700: '#5925DC',
    800: '#4A1FB8',
    900: '#3E1C96',
    950: '#27115F',
  },
  green: {
    25: '#f6fefc',
    50: '#f0fdf9',
    100: '#ccfbef',
    200: '#99f6e0',
    300: '#5fe9d0',
    400: '#2ed3b7',
    500: '#00C076', // Updated to match screenshot green
    600: '#0e9384',
    700: '#107569',
    800: '#125d56',
    900: '#134e48',
    950: '#0a2926',
  },
  blue: {
    25: '#f5f8ff',
    50: '#eff4ff',
    100: '#d1e0ff',
    200: '#b2ccff',
    300: '#84adff',
    400: '#528bff',
    500: '#2970ff',
    600: '#155eef',
    700: '#004eeb',
    800: '#0040c1',
    900: '#00359e',
    950: '#002266',
  },
  error: {
    25: '#fffbfa',
    50: '#fff1f2',
    100: '#ffe2e4',
    200: '#ffcacd',
    300: '#fea4a9',
    400: '#fd7279',
    500: '#FF4A4A', // Updated to match screenshot red
    600: '#e33135',
    700: '#bf262a',
    800: '#9e2124',
    900: '#822024',
    950: '#480b0d',
  },
  warning: {
    25: '#fffbeb',
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
    950: '#451a03',
  },
  success: {
    25: '#f6fef9',
    50: '#f1fcf8',
    100: '#d1f6ed',
    200: '#a2edda',
    300: '#6ddcc4',
    400: '#3fc4ac',
    500: '#23ab94',
    600: '#1c8777',
    700: '#1a6c61',
    800: '#19564f',
    900: '#194942',
    950: '#092b28',
  },
  grey: {
    25: '#fafafa',
    50: '#f7f7f7',
    100: '#f0f0f1',
    200: '#ececed',
    300: '#cecfd2',
    400: '#94979c',
    500: '#85888e',
    600: '#61656c',
    700: '#373a41',
    750: '#232323',
    800: '#22262f',
    900: '#13161b',
  },
  black: {
    25: '#f0f0f0',
    50: '#e6e6e6',
    100: '#cccccc',
    200: '#b3b3b3',
    300: '#808080',
    400: '#666666',
    500: '#4d4d4d',
    600: '#333333',
    700: '#1a1a1a',
    800: '#121212',
    900: '#000000',
  },
  // Additional commonly used colors
  ui: {
    border: '#969696',
    backgroundLight: '#2c2c2c',
    backgroundMedium: '#1e1e1e',
    backgroundDark: '#121212',
    cardBackground: '#212121',
    inputBackground: '#3C3C3C',
    inputBorder: '#5A5A5A',
    appBackground: '#000000', // Main app background color
  },
  semantic: {
    success: '#00C076', // Updated to match screenshot green
    error: '#FF4A4A', // Updated to match screenshot red
    warning: '#FF9830',
    info: '#60A5FA',
  },
};

export default palette;
